import React from "react";
import Icon, { IconName } from "../Icon/Icon.component";
import {
  ButtonVariant,
  StyledButton,
  StyledButtonLink,
} from "./Button.styled";

interface IButton {
  variant?: ButtonVariant;
  children: React.ReactNode;
  /** Renders an anchor instead of a button. */
  href?: string;
  target?: string;
  /** Trailing icon. Pass null for a button without one. */
  icon?: IconName | null;
  className?: string;
  onClick?: () => void;
}

const Button = ({
  variant = "primary",
  children,
  href,
  target,
  icon = "arrow",
  className,
  onClick,
}: IButton) => {
  const content = (
    <>
      {children}
      {icon && <Icon name={icon} />}
    </>
  );

  if (href) {
    return (
      <StyledButtonLink
        className={className}
        href={href}
        variant={variant}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        onClick={onClick}
      >
        {content}
      </StyledButtonLink>
    );
  }

  return (
    <StyledButton
      className={className}
      type="button"
      variant={variant}
      onClick={onClick}
    >
      {content}
    </StyledButton>
  );
};

export default Button;
